"use client";
import * as React from "react";
const SvgVisibilityOffSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 2.95a3.64 3.64 0 0 1 3.64 3.63q-.01.56-.18 1.06l2.23 2.23A8.6 8.6 0 0 0 16 6.57a8.6 8.6 0 0 0-8-5.44 9 9 0 0 0-2.65.41l1.58 1.58A4 4 0 0 1 8 2.94M1.76 0 .73 1.03l1.95 1.95A8.5 8.5 0 0 0 0 6.58a8.6 8.6 0 0 0 11.13 4.86l2.5 2.5 1.03-1.03zM8 10.22a3.64 3.64 0 0 1-3.64-3.64q0-.85.36-1.56l1.14 1.15-.04.41A2.2 2.2 0 0 0 8 8.76q.21 0 .42-.05l1.14 1.14a3.5 3.5 0 0 1-1.56.37m2.16-3.88a2.16 2.16 0 0 0-1.92-1.92z" }));
export {
  SvgVisibilityOffSharp as default
};
